import React from 'react';
import { Building } from '~/types/building';
import { ReactComponent as BuildingPlaceholder } from '~/utils/images/building.svg';
import classes from './BuildingCard.module.css';

interface IProps {
  onClick: (uuid: string, building: Building) => void;
  buildingCard: Building;
}

const BuildingCard = (props: IProps) => {
  const { buildingCard } = props;

  return (
    <div
      className={classes.buildingCardContainer}
      onClick={() => props.onClick(buildingCard.uuid, buildingCard)}
    >
      {buildingCard.image && (
        <div className={`${classes.buildingCard} ${classes.buildingCardImg}`}>
          <img
            src={buildingCard.image}
            alt={buildingCard.name}
            className={classes.buildingCardImgTag}
            loading='lazy'
            decoding='async'
          />
          <div className={`${classes.buildingCardOverlay} pointer`} />
        </div>
      )}

      {!buildingCard.image && (
        <div
          className={`${classes.buildingCard} ${classes.defaultImageBuilding} pointer`}
        >
          <BuildingPlaceholder />
        </div>
      )}
      <p
        className={`${classes.buildingCardTitle}`}
        title={buildingCard.name}
      >
        {buildingCard.name}
      </p>
    </div>
  );
};

export default BuildingCard;
